import { CreateRunPage } from '@/features/calibration-runs/components/create-run/create-run-page';

export function NewRunPage() {
  return <CreateRunPage />;
}
